// extracted by mini-css-extract-plugin
module.exports = {"navlist":"NavList-module--navlist--3Xaz9","isPrimary":"NavList-module--isPrimary--1N94s"};